import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "gfu-grid gfu-grid--gutter gfua-gallery__container",
  "data-qa": "project-gallery"
}
const _hoisted_2 = { class: "gfua-gallery__item-content" }
const _hoisted_3 = ["onDrop", "onDragenter", "onDragleave"]
const _hoisted_4 = {
  class: "gfu-block-editor__number _mt-a",
  draggable: "false"
}
const _hoisted_5 = {
  key: 0,
  class: "gfu-block-editor__media-wrapper"
}
const _hoisted_6 = ["onClick", "data-qa"]
const _hoisted_7 = {
  key: 1,
  class: "gfu-block-editor__media-wrapper"
}
const _hoisted_8 = ["onClick", "data-qa"]
const _hoisted_9 = { class: "gfua-gallery__item-content" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_notificator = _resolveComponent("notificator")
  const _component_block_editor_single_icon_prefix = _resolveComponent("block-editor-single-icon-prefix")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_block_editor = _resolveComponent("block-editor")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_block_editor_draggable_prefix = _resolveComponent("block-editor-draggable-prefix")
  const _component_dropdown_link = _resolveComponent("dropdown-link")
  const _component_dropdown_group = _resolveComponent("dropdown-group")
  const _component_update_image_modal = _resolveComponent("update-image-modal")
  const _component_update_video_modal = _resolveComponent("update-video-modal")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_notificator, {
      ref: "notify",
      singular: true
    }, null, 512 /* NEED_PATCH */),
    _createElementVNode("div", _hoisted_1, [
      (!$props.readOnly)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass($options.galleryItemClass)
          }, [
            _createVNode(_component_block_editor, {
              class: "gfua-gallery__placeholder",
              empty: true,
              "content-transparent": true
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_block_editor_single_icon_prefix, {
                  icon: "plus",
                  "icon-position": "center"
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(['gfua-gallery__placeholder-content', $options.galleryImageClass])
                }, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['gfua-gallery__item-placeholder gfu-block-editor__media-placeholder', $props.showVideos ? '_flexb50' : 'gfu-flex__item gfu-flex__item--grow']),
                      onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($options.openUpdateImageModal(null)), ["prevent"])),
                      "data-qa": "gallery-settings-button:AddImage"
                    }, [
                      _createVNode(_component_base_icon, { name: "image" }),
                      _cache[5] || (_cache[5] = _createTextVNode(" add image ", -1 /* CACHED */))
                    ], 2 /* CLASS */),
                    ($props.showVideos)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "gfua-gallery__item-placeholder gfu-block-editor__media-placeholder _flexb50",
                          onClick: _cache[1] || (_cache[1] = _withModifiers($event => ($options.openUpdateVideoModal(null)), ["prevent"])),
                          "data-qa": "gallery-settings-button:AddVideo"
                        }, [
                          _createVNode(_component_base_icon, {
                            name: "youtube",
                            "icon-namespace": "brands"
                          }),
                          _cache[6] || (_cache[6] = _createTextVNode(" add video ", -1 /* CACHED */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ], 2 /* CLASS */)
              ]),
              _: 1 /* STABLE */
            })
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.gallery, (galleryItem, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: galleryItem.galleryItemID,
          class: _normalizeClass($options.galleryItemClass),
          onDrop: $event => ($options.handleDrop(galleryItem)),
          onDragover: _cache[2] || (_cache[2] = (...args) => ($options.handleDragOver && $options.handleDragOver(...args))),
          onDragenter: $event => ($options.handleDragEnter(galleryItem)),
          onDragleave: $event => ($options.handleDragLeave(galleryItem))
        }, [
          _createVNode(_component_block_editor, {
            ref_for: true,
            ref: 'gallery-item-' + galleryItem.galleryItemID
          }, {
            prefix: _withCtx(() => [
              _createVNode(_component_block_editor_draggable_prefix, {
                "allow-drag": !$props.readOnly,
                "drag-element-class": $options.galleryImageClass,
                onDragstart: $event => ($options.handleDragStart(galleryItem, $event)),
                onDragend: $options.handleDragEnd
              }, {
                default: _withCtx(() => [
                  ($options.isImage(galleryItem))
                    ? (_openBlock(), _createBlock(_component_base_icon, {
                        key: 0,
                        name: "image",
                        draggable: "false"
                      }))
                    : ($options.isVideo(galleryItem))
                      ? (_openBlock(), _createBlock(_component_base_icon, {
                          key: 1,
                          name: "youtube",
                          "icon-namespace": "brands",
                          draggable: "false"
                        }))
                      : _createCommentVNode("v-if", true),
                  ($props.readOnly)
                    ? (_openBlock(), _createBlock(_component_tooltip, {
                        key: 2,
                        draggable: "false",
                        text: "This campaign phase is already closed. You can't edit it."
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_base_icon, {
                            name: "ban",
                            class: "_mt-3"
                          })
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true),
                  (!$props.readOnly)
                    ? (_openBlock(), _createBlock(_component_base_icon, {
                        key: 3,
                        name: "grip-lines",
                        class: "gfu-block-editor-prefix-icon gfu-block-editor-prefix-icon--centered"
                      }))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", _hoisted_4, _toDisplayString(index + 1), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["allow-drag", "drag-element-class", "onDragstart", "onDragend"])
            ]),
            actions: _withCtx(() => [
              _createVNode(_component_dropdown_group, { fixed: false }, {
                default: _withCtx(() => [
                  (!$props.readOnly)
                    ? (_openBlock(), _createBlock(_component_dropdown_link, {
                        key: 0,
                        icon: "trash-alt",
                        label: "Delete",
                        onClick: $event => ($options.deleteGalleryItem(galleryItem)),
                        "data-qa": `gallery-item-delete-btn:${galleryItem.galleryItemID}`
                      }, null, 8 /* PROPS */, ["onClick", "data-qa"]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */)
            ]),
            default: _withCtx(() => [
              ($options.isImage(galleryItem))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['gfu-block-editor__media', $options.galleryImageClass]),
                      style: _normalizeStyle({ backgroundImage: 'url(' + galleryItem.imageUrl + ')' }),
                      onClick: $event => ($options.openUpdateImageModal(galleryItem)),
                      "data-qa": `gallery-image:${galleryItem.galleryItemID}`
                    }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_6)
                  ]))
                : ($options.isVideo(galleryItem))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", {
                        class: _normalizeClass(['gfu-block-editor__media', $options.galleryImageClass]),
                        style: _normalizeStyle({ backgroundImage: 'url(' + $options.getVideoUrl(galleryItem) + ')' }),
                        onClick: $event => ($options.openUpdateVideoModal(galleryItem)),
                        "data-qa": `gallery-video:${galleryItem.galleryItemID}`
                      }, null, 14 /* CLASS, STYLE, PROPS */, _hoisted_8)
                    ]))
                  : _createCommentVNode("v-if", true)
            ]),
            _: 2 /* DYNAMIC */
          }, 1536 /* NEED_PATCH, DYNAMIC_SLOTS */)
        ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_3))
      }), 128 /* KEYED_FRAGMENT */)),
      ($data.gallery.length > 5)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass($options.galleryItemClass)
          }, [
            _createVNode(_component_block_editor, {
              class: "gfua-gallery__placeholder",
              empty: true,
              "content-transparent": true
            }, {
              prefix: _withCtx(() => [
                _createVNode(_component_block_editor_single_icon_prefix, {
                  "icon-name": "plus",
                  "icon-position": "center"
                })
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(['gfua-gallery__placeholder-content', $options.galleryImageClass]),
                  "data-qa": "gallery-settings:Image"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", {
                      class: _normalizeClass(['gfua-gallery__item-placeholder gfu-block-editor__media-placeholder', $props.showVideos ? '_flexb50' : 'gfu-flex__item gfu-flex__item--grow']),
                      onClick: _cache[3] || (_cache[3] = _withModifiers($event => ($options.openUpdateImageModal(null)), ["prevent"])),
                      "data-qa": "gallery-settings-button:AddImage"
                    }, [
                      _createVNode(_component_base_icon, { name: "image" }),
                      _cache[7] || (_cache[7] = _createTextVNode(" add image ", -1 /* CACHED */))
                    ], 2 /* CLASS */),
                    ($props.showVideos)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "gfua-gallery__item-placeholder gfu-block-editor__media-placeholder _flexb50",
                          onClick: _cache[4] || (_cache[4] = _withModifiers($event => ($options.openUpdateVideoModal(null)), ["prevent"])),
                          "data-qa": "gallery-settings-button:AddVideo"
                        }, [
                          _createVNode(_component_base_icon, {
                            name: "youtube",
                            "icon-namespace": "brands"
                          }),
                          _cache[8] || (_cache[8] = _createTextVNode(" add video ", -1 /* CACHED */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ])
                ], 2 /* CLASS */)
              ]),
              _: 1 /* STABLE */
            })
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode(_component_update_image_modal, {
      ref: "updateImageModal",
      ratio: $options.aspectRatio,
      "upload-api-action": $props.uploadTempImageApiAction,
      onUploadImage: $options.uploadImage
    }, null, 8 /* PROPS */, ["ratio", "upload-api-action", "onUploadImage"]),
    ($props.showVideos)
      ? (_openBlock(), _createBlock(_component_update_video_modal, {
          key: 0,
          ref: "updateVideoModal",
          ratio: $options.aspectRatio,
          "upload-api-action": $props.uploadTempImageApiAction,
          onUploadVideoImage: $options.uploadVideoImage
        }, null, 8 /* PROPS */, ["ratio", "upload-api-action", "onUploadVideoImage"]))
      : _createCommentVNode("v-if", true)
  ]))
}